// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"134":"86217186","483":"86217186","592":"86217186"}[chunkId] + ".chunk.css";
};